var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { pageImages } from "@/pages/images";
import { StepLayout } from "../step-layout.component";
import { Typography } from "@mui/material";
import { UserDetailsForm } from "./user-details-form.component";
import { NavigationButton, NavigationButtonsContainer } from "../navigation-button.component";
export function SendResultsComponent() {
    return (_jsx(StepLayout, { image: pageImages.womanBrowsing, progress: {
            phase: 0,
            step: 3,
        }, heading: _jsx(Typography, __assign({ variant: "h3", className: "md:pt-6 lg:pt-12 xl:pt-[72px] font-extrabold text-charcoal text-2xl lg:text-4xl" }, { children: "Where should we send your results?" })), content: _jsx(UserDetailsForm, {}), nav: _jsxs(NavigationButtonsContainer, __assign({ className: "mb-6" }, { children: [_jsx(NavigationButton, { type: "back", variant: "outlined", label: "Previous" }), _jsx(NavigationButton, { type: "submit", variant: "contained", label: "Next" })] })) }));
}
